import React from 'react';

/**
 * Description
 *
 * Renders a description to be used within a widget component.
 *
 * @param initiativeType
 * @param remediationType
 * @param scopeCode
 * @returns {Element}
 * @constructor
 */
export function Description({ initiativeType = '', remediationType = '', scopeCode = '' }) {
  return (
    <React.Fragment>
      {scopeCode === 'CURRENT_FUTURE' && (
        <p style={{ marginBottom: '2px' }}>
          The following actions will be applied to <strong>current records</strong> and <strong>future records</strong>:
        </p>
      )}
      {scopeCode === 'FUTURE' && (
        <p style={{ marginBottom: '2px' }}>
          The following actions will be applied to apply to <strong>future records</strong> only:
        </p>
      )}
      <p style={{ marginBottom: '2px' }}>
        Remediation Type: <strong>{remediationType}</strong>
      </p>
      <p style={{ marginBottom: 0 }}>
        Initiative Type: <strong>{initiativeType == '' ? 'NONE' : initiativeType}</strong>
      </p>
    </React.Fragment>
  );
}
